export interface ReferralSourceInterface {
  id: string;
  name: string;
  agency: string;
  description?: string;
  email?: string;
  phoneType?: string;
  phoneNumber?: string;
  phoneExtension?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  locationId?: string;
}

export class ReferralSource implements ReferralSourceInterface {
  id: string;
  name: string;
  agency: string;
  description?: string;
  email?: string;
  phoneType?: string;
  phoneNumber?: string;
  phoneExtension?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  locationId?: string;

  constructor(data: Partial<ReferralSourceInterface>) {
    this.id = data.id!;
    this.name = data.name!;
    this.agency = data.agency!;
    this.description = data.description;
    this.email = data.email;
    this.phoneType = data.phoneType;
    this.phoneNumber = data.phoneNumber;
    this.phoneExtension = data.phoneExtension;
    this.address = data.address;
    this.city = data.city;
    this.state = data.state;
    this.zip = data.zip;
    this.locationId = data.locationId;
  }

  toJson(): ReferralSourceInterface {
    return {
      id: this.id,
      name: this.name,
      agency: this.agency,
      description: this.description,
      email: this.email,
      phoneType: this.phoneType,
      phoneNumber: this.phoneNumber,
      phoneExtension: this.phoneExtension,
      address: this.address,
      city: this.city,
      state: this.state,
      zip: this.zip,
      locationId: this.locationId,
    };
  }
}
